import { render, staticRenderFns } from "./EditImages.vue?vue&type=template&id=0f476c71&scoped=true&"
import script from "./EditImages.vue?vue&type=script&lang=js&"
export * from "./EditImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f476c71",
  null
  
)

export default component.exports